// extracted by mini-css-extract-plugin
export default {"typography-heading":"EssentialDetailsForm_typography-heading__NqBP5","info-icon":"EssentialDetailsForm_info-icon__P5SGt"};